import { LANGS, useI18n } from "@/i18n";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang } = useI18n();
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="lang-switcher">
      {LANGS.map(([code, label]) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          data-testid={`lang-${code}`}
          aria-current={lang === code}
          className={`px-2 py-1 text-[11px] tracking-[0.18em] ${
            lang === code ? "bg-brass text-ink" : "text-bone/72 hover:text-brass"
          }`}
          style={{ transition: "color .3s ease, background-color .3s ease" }}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
